import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  /** Çekmecenin altına yerleştirilecek kontroller (tema/dil/kullanıcı/çıkış). */
  children?: React.ReactNode;
}

const navItems = [
  { path: '/workspace', icon: 'fa-folder-tree', labelKey: 'sidebar.workspace' },
  { path: '/passwords', icon: 'fa-key', labelKey: 'sidebar.passwords' },
];

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose, children }) => {
  const { t } = useTranslation();
  const location = useLocation();

  // Açıkken body scroll'u kilitle
  useEffect(() => {
    if (isOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9990] lg:hidden">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50" onClick={onClose} aria-hidden />
      {/* Drawer */}
      <div className="absolute top-0 left-0 h-full w-72 max-w-[85vw] bg-white dark:bg-gray-800 shadow-xl border-r border-gray-200 dark:border-gray-700 flex flex-col">
        <div className="flex items-center justify-between px-4 h-[60px] border-b border-gray-200 dark:border-gray-700">
          <span className="text-lg font-medium text-gray-500 dark:text-gray-300 font-maven">SmartPM</span>
          <button
            type="button"
            onClick={onClose}
            className="p-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
            aria-label={t('common.close', 'Kapat')}
          >
            <i className="fa-solid fa-times text-lg" />
          </button>
        </div>
        <nav className="flex-1 overflow-y-auto p-3">
          <ul className="space-y-1">
            {navItems.map((item) => {
              const active = location.pathname === item.path;
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    onClick={onClose}
                    className={`flex items-center gap-3 px-3 py-3 rounded-lg transition-colors ${
                      active
                        ? 'bg-primary text-white'
                        : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
                    }`}
                  >
                    <i className={`fa-solid ${item.icon} text-sm w-5 text-center`} />
                    <span className="font-medium text-sm">{t(item.labelKey)}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
        {children && (
          <div className="border-t border-gray-200 dark:border-gray-700 p-3 space-y-2">{children}</div>
        )}
      </div>
    </div>
  );
};

export default MobileMenu;
